import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';

// Actions
import { confirmSubscription, resolveSubscription } from '../../../store/login';

// View
import MicrosoftConfirmSubscription from './MicrosoftConfirmSubscription';

const mapDispatchToProps = {
  confirmSubscription,
  resolveSubscription,
};

const mapStateToProps = (state, ownProps) => ({
  status: state.login.status,
  subscriptionConfirmationStatus: state.login.subscriptionConfirmationStatus,
  subscriptionData: state.login.subscriptionData,
  subscriptionConfirmationData: state.login.subscriptionConfirmationData,
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(MicrosoftConfirmSubscription);
